<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Package Group Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase">
                Test Pachage Group Identification
              </span>
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="Name" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.name"
                  placeholder="Enter Test Package Group Name"
                  invalid-feedback="Required"
                  :state="!$v.form_data.name.$invalid"
                />
              </b-form-group>
              <b-form-group label="Position" :label-cols="2">
                <b-form-input
                  v-model.number="form_data.position"
                  :min="0"
                  type="number"
                  placeholder="Enter Test Package Group Position"
                />
              </b-form-group>
              <b-form-group
                label="Sample Type"
                :label-cols="2"
                invalid-feedback="Required"
                :state="!$v.form_data.sample_type_id.$invalid"
              >
                <multiselect
                  v-model="selected_sample_type"
                  :value="sample_type_value"
                  :options="sample_type_options"
                  :multiple="false"
                  track-by="id"
                  label="name"
                />
              </b-form-group>
              <b-form-group label="Description" :label-cols="2">
                <b-form-textarea
                  v-model="form_data.description"
                  placeholder="Enter Test Package Group Description"
                />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="submitForm"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-address-book" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect/src/Multiselect";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate/src";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "TestPackageGroupForm",
  components: {
    Multiselect,
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    test_package_group: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: true,
      form_data: {
        sample_type_id: null,
        name: null,
        description: null,
        position: 0,
      },
      sample_type_options: null,
      sample_type_value: {},
      sample_type_collection: null,
    };
  },
  computed: {
    selected_sample_type: {
      get() {
        return this.sample_type_value;
      },
      set(value) {
        this.sample_type_value = value;
        this.form_data.sample_type_id = value && value.id;
      },
    },
  },
  validations: {
    form_data: {
      name: { required },
      sample_type_id: { required },
    },
  },
  methods: {
    submitForm() {
      return this.$emit("submit", this.form_data);
    },
    initFormData() {
      const { sample_type_id, description } = this.test_package_group;

      this.form_data = {
        ...this.test_package_group.cloneAttributes(true, true, [
          "id",
          "created_at",
          "deleted_at",
          "updated_at",
          "laboratory",
          "sample_type",
        ]),
        description,
      };

      sample_type_id &&
        (this.sample_type_value = this.sample_type_options.find(
          ({ id }) => id === sample_type_id
        ));
    },
    async init() {
      this.sample_type_collection = await getCollection({
        collection_type: "sample_type",
        sort: [
          {
            logic: "sortAddAsc",
            field: "name",
          },
        ],
        message: this.$bvToast,
      });

      this.sample_type_options = this.sample_type_collection.models.map(
        ({ id, name }) => {
          return {
            id,
            name,
          };
        }
      );

      this.test_package_group && this.initFormData();

      this.loading = false;
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
};
</script>
